import { render } from "./dashboard-header.vue?vue&type=template&id=8bc509f2"
import script from "./dashboard-header.vue?vue&type=script&lang=js"
export * from "./dashboard-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__